<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="6"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Users
            </h1>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-right mb-1"
        cols="6"
      >
        <b-button
          v-if="canViewThisAction('create', 'User')"
          variant="success"
          :to="{ name: 'directory-users-create' }"
          class="mobile_create_button mr-50"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle d-md-block d-none">Create New User</span>
          <span class="align-middle d-md-none d-block">New</span>
        </b-button>
        <b-button
          v-if="canViewThisAction('request-user-creation', 'UserCreationRequest')"
          variant="success"
          :to="{ name: 'directory-users-request-create' }"
          class="mobile_create_button"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle d-md-block d-none">Request for New User Account</span>
          <span class="align-middle d-md-none d-block">New Request</span>
        </b-button>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>

              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-block-out-form"
                ref="filter_dropdown_user"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <user-filters
                  :status-filter.sync="statusFilter"
                  :department-filter.sync="departmentFilter"
                  :role-filter.sync="roleFilter"
                  :status-radio-options="statusRadioOptions"
                  :department-options="departmentOptions"
                  :role-options="roleOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>

        <div v-if="departmentFilter.length || (roleFilter && !$route.params.id) || statusFilter">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="departmentVal in departmentFilter"
                  :key="departmentVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromDepartmentFilter(departmentVal)"
                  >
                    <span class="text-capitalize">{{ resolveDepartmentName(departmentVal) }}</span>
                  </b-form-tag>
                </li>

                <li
                  v-if="roleFilter && !$route.params.id"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="roleFilter = ''"
                  >
                    <span class="text-capitalize">{{ resolveRoleName(roleFilter) }}</span>
                  </b-form-tag>
                </li>

                <li
                  v-if="statusFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="statusFilter = null"
                  >
                    <span class="text-capitalize">{{ statusFilter }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refUsersTable"
        class="position-relative min-height-150"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Role -->
        <template #cell(name)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'User')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'directory-users-show', params: { id: data.item._id } }"
            >
              {{ data.item.name }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.name }}
            </b-button>
          </div>
        </template>

        <template #cell(department)="data">
          <div class="">
            <p
              v-for="(department, key) in data.item.department"
              :key="key"
              class="mb-0"
            >
              {{ department.name }}
            </p>
          </div>
        </template>

        <template #cell(roles)="data">
          <!-- <b-badge
            v-for="field in data.item.roles"
            :key="field._id"
            pill
            variant="secondary"
          >
            {{ field.role }}
          </b-badge> -->
          <div class="demo-inline-spacing">
            <b-button
              v-for="(role, key) in data.item.roles"
              :key="key"
              :title="role.role"
              variant="outline-dark"
              class="small-badge-button"
            >
              {{ role.role }}
            </b-button>
          </div>
        </template>

        <template #cell(twoFA)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.twoFA ? 'Yes' : 'No' }}</span>
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
          </div>
        </template>

        <template #cell(updatedAt)="data">
          <div class="text-nowrap">
            <span class="">{{ dateFormatWithTime(data.item.updatedAt) }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolveUserStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'User') || canViewThisAction('update', 'User') || canViewThisAction('delete', 'User')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'User')"
              :to="{ name: 'directory-users-show', params: { id: data.item._id } }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'User')"
              :to="{ name: 'directory-users-edit', params: { id: data.item._id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('request-user-edit', 'UserCreationRequest')"
              :to="{ name: 'directory-users-edit-request', params: { id: data.item._id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Request for User Account Update</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('delete', 'User') && data.item.status !== 'deleted'"
              @click="deleteEntity(data.item._id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalUsers > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalUsers"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BButton, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormTag,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import useUsersList from './useUsersList'
import userStoreModule from './userStoreModule'
import UserFilters from './UserFilters.vue'
// import UserListAddNew from './UserListAddNew.vue'

export default {
  components: {
    // UserListAddNew,
    BFormTag,
    BCard,
    BRow,
    BButton,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

    UserFilters,
  },
  directives: {
    Ripple,
  },
  props: {
    roleId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      departmentOptions: [],
      roleOptions: [],
      statusRadioOptions: [
        { text: 'Active', value: 'active' },
        { text: 'Inactive', value: 'inactive' },
        { text: 'Pending Approval', value: 'pending approval' },
      ],
    }
  },

  beforeMount() {
    this.$http.get('directory/users/respond-with/extra-options')
      .then(response => {
        this.roleOptions = response.data.roleOptions ?? []
        this.departmentOptions = response.data.departments ?? []
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_user.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_user.show(true)
    },
    removeFromDepartmentFilter(item) {
      const index = this.departmentFilter.indexOf(item)
      if (index > -1) {
        this.departmentFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.roleFilter = ''
      this.departmentFilter = []
      this.statusFilter = null
    },
    resolveDepartmentName(id) {
      const dept = this.departmentOptions.find(o => o._id === id)
      if (dept) {
        return dept.name || ''
      }
      return ''
    },
    resolveRoleName(id) {
      const role = this.roleOptions.find(o => o._id === id)
      if (role) {
        return role.role || ''
      }
      return ''
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Warning!',
        text: ' Are you sure you want to delete this?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, Cancel',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.toDeletedID = id
            this.deleteUser()
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const USER_APP_STORE_MODULE_NAME = 'app-users'

    // console.log(props.roleId)

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
      { label: 'Pending Approval', value: 'pending approval' },
    ]

    const { canViewThisAction } = useAclUtils()

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUsersTable,
      refetchData,

      toDeletedID,
      deleteUser,
      currentDataLength,

      // UI
      resolveUserStatusVariant,

      // Extra Filters
      statusFilter,
      roleFilter,
      teamFilter,
      departmentFilter,
    } = useUsersList()

    return {

      // Sidebar

      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUsersTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deleteUser,
      currentDataLength,

      // Filter
      avatarText,

      // UI
      resolveUserStatusVariant,

      canViewThisAction,

      statusOptions,

      // Extra Filters
      statusFilter,
      roleFilter,
      teamFilter,
      departmentFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
